import { render } from "./gsrcu0201.vue?vue&type=template&id=63603de0&scoped=true"
import script from "./gsrcu0201.vue?vue&type=script&lang=js"
export * from "./gsrcu0201.vue?vue&type=script&lang=js"

import "./gsrcu0201.vue?vue&type=style&index=0&id=63603de0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63603de0"]])

export default __exports__